"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var Checkbox = function Checkbox(props) {
  return _react["default"].createElement(_Checkbox["default"], props);
};

Checkbox.defaultProps = {
  color: 'primary'
};
Checkbox.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes["default"].node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes["default"].object,

  /**
   * @ignore
   */
  className: _propTypes["default"].string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes["default"].oneOf(['primary', 'secondary', 'default']),

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes["default"].bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes["default"].node,

  /**
   * The id of the `input` element.
   */
  id: _propTypes["default"].string,

  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the input.
   */
  indeterminate: _propTypes["default"].bool,

  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: _propTypes["default"].node,

  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes["default"].object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes["default"].func,

  /**
   * The input component property `type`.
   */
  type: _propTypes["default"].string,

  /**
   * The value of the component.
   */
  value: _propTypes["default"].string
} : {};
var _default = Checkbox;
exports["default"] = _default;